import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Row, Col, Card, InputGroup } from "react-bootstrap";
import { BsCartPlusFill } from "react-icons/bs";

export const MemberProductCart = ({ pass, setValue, onClick }) => {
  const cardDetail = pass;

  const [selectedPasses, setSelectedPasses] = useState([]);

  const handleCheckboxChange = (event, passId) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setSelectedPasses((prevSelectedPasses) => [
        ...prevSelectedPasses,
        passId,
      ]);
    } else {
      setSelectedPasses((prevSelectedPasses) =>
        prevSelectedPasses.filter((selectedPass) => selectedPass !== passId)
      );
    }
  };

  useEffect(() => {
    if (setValue) {
      setValue(selectedPasses);
    }
  }, [selectedPasses]);

  return (
    <>
      {cardDetail && cardDetail.length > 0 ? (
        <Row>
          {cardDetail.map((value, index) => (
            <Col key={index} lg={4} md={4} sm={12} onClick={()=>onClick((value.service_type),value,(value.quantity))}>
              <Card className="blueback-pass" key={index}>
              <span className="AddCartHover">
                <BsCartPlusFill />
              </span>
                <div className="cardImg">
                  <Card.Img variant="top" src={value.memberShipImg} />
                  <p>{value.validText}</p>
                </div>
                <Card.Body>
                  <Card.Title>{value.cardTitle} </Card.Title>
                  <Card.Text>
                    {parseFloat(value.price).toFixed(2)} <small>{value.taxTaxt ? value.taxTaxt : parseFloat(value.tax).toFixed(2)}</small>
                  </Card.Text>
                </Card.Body>
                {/* <InputGroup.Checkbox
                  name="pass[]"
                  className="membercheckbox"
                  value={value.pass_id}
                  aria-label="Checkbox for following text input"
                  onChange={(event) =>
                    handleCheckboxChange(event, value.pass_id)
                  }
                /> */}
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        ""
      )}
    </>
  );
};
